import { Stack, usePathname } from 'expo-router';
import { Platform } from 'react-native';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';

export default function Trips() {
  const { theme } = useStyles();
  const pathname = usePathname();

  if (
    Platform.OS === 'web' &&
    ['md', 'lg'].includes(UnistylesRuntime.breakpoint)
  ) {
    return (
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: {
            backgroundColor: theme.colors.background_1,
          },
        }}
      />
    );
  }

  return (
    <Stack
      screenOptions={{
        headerShown: pathname === '/trips',
        headerTitle: 'Trips',
        headerTitleAlign: 'center',
        contentStyle: {
          backgroundColor: theme.colors.background_1,
        },
        headerStyle: {
          backgroundColor: theme.colors.background_1,
        },
        headerTintColor: theme.colors.text.primary,
        headerShadowVisible: false,
        headerLeft: () => null,
        headerBackVisible: false,
      }}
    >
      <Stack.Screen
        name="[id]/details/index"
        options={{
          title: '',
          headerTitle: '',
          headerShown: true,
          headerLeft: () => <BackButton />,
        }}
      />

      <Stack.Screen
        name="[id]/recharge/index"
        options={{
          title: 'On-Demand Recharging',
          headerTitle: 'On-Demand Recharging',
          headerShown: true,
          headerBackVisible: false,
          headerLeft: () => <BackButton />,
        }}
      />
    </Stack>
  );
}
